import React, { useState } from 'react';
import Icon  from '../../global/icons/Icon'
import { IconLibrary } from '../../../interfaces/icon/IconLibrary';

const CopyToClipboard = ({className, textToCopy, iconOnly}: {className?: string, textToCopy: string, iconOnly?:boolean}) => {

    const [copyState, setCopyState] = useState<'ready' | 'success' | 'fail'>('ready');

    async function handleClick(){
        try {
            await navigator.clipboard.writeText(textToCopy)
            setCopyState('success');
        }
        catch{
            setCopyState('fail');
        }
        finally {
            setTimeout(() => {
                setCopyState('ready');
            }, 3000)
        }
    }

    const getButtonContents = () => {
        switch (copyState) {
            case 'ready': 
                return <>
                    {!iconOnly && <span>Copy to clipboard</span>}
                    <Icon iconName={IconLibrary.COPY} color='var(--thriveGreyDark)' sizeInPx='16'/>
                </>
            case 'success': 
                return <>
                    {!iconOnly && <span>Copied to clipboard</span>}
                    <Icon iconName={IconLibrary.CIRCLE_CHECK} color='var(--thriveWhite)' sizeInPx='16'/>
                </>
            case 'fail': 
                return <>
                    {!iconOnly && <span>Could not copy</span>}
                    <Icon iconName={IconLibrary.CIRCLE_CLOSE} color='var(--thriveWhite)' sizeInPx='16'/>
                </>
        }
    }

    return (
        <button
            className={`basic-button TC-c2c-button ${copyState} ${className ?? ''}`}
            name='copy to clipboard'
            onClick={handleClick}
            aria-label={'copy to clipboard'}
            disabled={copyState !== 'ready'}
        >
            {getButtonContents()}
        </button>)
} 

export default CopyToClipboard
